export enum PIN_TYPE {
  TOPIC = 'topic',
  COMMENT = 'comment',
  SHARED_FOLDER = 'shared_folder'
}

export interface PINNED_ITEM {
  id: number
  is_pin: boolean
  type: PIN_TYPE,
  groupId?: string
}
